import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import ArrowRightIcon from '@icons/ArrowRightIcon';
import ErrorHandler from '../../_molecules/ErrorHandler';
import MemberProfile from '../../_organisms/MemberProfile';
import { LinkSmall } from '@styled';

import colors from '@general/colors';
import useIcscTracking from '@tracking/useIcscTracking';
import LoadingArea from '@molecules/LoadingArea';
import { getGraphIdFromURL } from '@general/helpers/urlParsing.helpers';

const MemberProfilePage = () => {
    const location = useLocation();
    const history = useHistory();
    const graphID = getGraphIdFromURL();

    const { Track } = useIcscTracking({
        app_area: 'Member Profile',
    });

    const goBack = () => {
        history.goBack();
    };

    const handleKeyPress = e => {
        e.preventDefault();
        if (e.keyCode === 13) {
            goBack();
        }
    };

    if (!graphID) {
        return <LoadingArea />;
    }

    return (
        <ErrorHandler>
            <Track>
                <div className="px-md-4 py-4">
                    {/* if there is no graphID in router, then it's not routed through react */}
                    {location?.state?.graphID && (
                        <LinkSmall
                            className="cursor-pointer px-3 px-md-1 px-xl-4"
                            tabIndex={0}
                            role="link"
                            onKeyDown={handleKeyPress}
                            onClick={() => goBack()}
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            <ArrowRightIcon
                                color={colors.primary}
                                style={{ transform: 'rotate(180deg)', marginRight: '5px' }}
                            />{' '}
                            Back
                        </LinkSmall>
                    )}

                    <MemberProfile graphID={graphID} />
                </div>
            </Track>
        </ErrorHandler>
    );
};

MemberProfilePage.propTypes = {};

export default MemberProfilePage;
